<template>
    <div class="listing-detail-banner standard" ref="banner" :style="rootStyle">
        <!-- mobile top banner start -->
        <template v-if="isMobileSize">
            <div class="save-share-container" v-sticky="{ class: 'fixed' }">
                <div class="left-btn" @click="putAway">
                    <span class="btn-putAway iconfont icon-boldarrow"></span>
                    <span class="btn-text">{{
                        $t('md-detail-info.search')
                    }}</span>
                </div>
                <div class="right-btn">
                    <shake-animate>
                        <template #default="shakeStyle">
                            <div
                                class="item save"
                                :class="[!hasFavor && shakeStyle.animate]"
                                @click="onFavClick"
                                v-if="!isSoldHouse"
                            >
                                <span
                                    class="iconfont"
                                    :class="[
                                        hasFavor && !!user
                                            ? 'icon-heart-fill'
                                            : 'icon-heart'
                                    ]"
                                ></span>
                            </div>
                        </template>
                    </shake-animate>
                    <div class="item share" v-if="notApp" @click="sharePop">
                        <span class="iconfont icon-big-normal-share"></span>
                    </div>
                </div>
            </div>
        </template>
        <!-- mobile top banner start -->
        <!-- pc top banner start -->
        <template v-else>
            <div
                class="fixed-banner"
                :class="{ fixed: showFixedBanner }"
                :style="fixedBannerStyle"
            >
                <div class="banner-box mg-container">
                    <div class="banner-left" v-if="prevAndNext.show">
                        <template v-if="prevAndNext.canPrev">
                            <a
                                class="btn"
                                :href="prevAndNext.prevHref || null"
                                self="true"
                                rel="noopener noreferrer"
                            >
                                <span
                                    class="iconfont icon-next-big prev"
                                ></span>
                                <span class="text">{{
                                    $t('md-detail-info.prev')
                                }}</span>
                            </a>
                            <div class="bg-img-box">
                                <site-img
                                    :src="prevAndNext.prevImg"
                                    class="bg-img"
                                />
                            </div>
                        </template>
                    </div>
                    <div class="center mg-container">
                        <div class="price-address">
                            <price class="price" />
                            <addr class="address" />
                        </div>
                        <div class="save-share-tour">
                            <shake-animate>
                                <template #default="shakeStyle">
                                    <span
                                        class="item save"
                                        @click="onFavoriteClick"
                                        v-if="!isSoldHouse"
                                        :class="[
                                            hasFavor ? 'active' : '',
                                            !hasFavor && shakeStyle.animate
                                        ]"
                                    >
                                        <i
                                            class="iconfont icon-heart default"
                                        ></i>
                                        <i
                                            class="iconfont icon-heart-fill hover"
                                        ></i>
                                    </span>
                                </template>
                            </shake-animate>
                            <span class="item share">
                                <i
                                    class="iconfont icon-v2-share-Normal default"
                                ></i>
                                <!-- hover share icon -->
                                <i
                                    class="iconfont icon-v2-share-hover hover"
                                ></i>
                                <share-popper
                                    class="popper"
                                    :shares="shares"
                                    :theme="theme"
                                    :listingId="info.id"
                                />
                            </span>
                            <span
                                @click="schedulePop"
                                class="item tour"
                                v-if="!isSoldHouse"
                            >
                                <span class="text">{{
                                    $t('md-detail-info.scheduleATour')
                                }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="banner-right" v-if="prevAndNext.show">
                        <template v-if="prevAndNext.canNext">
                            <a
                                class="btn"
                                :href="prevAndNext.nextHref || null"
                                self="true"
                                rel="noopener noreferrer"
                            >
                                <span class="text">{{
                                    $t('md-detail-info.next')
                                }}</span>
                                <span
                                    class="iconfont icon-next-big next"
                                ></span>
                            </a>
                            <div class="bg-img-box">
                                <site-img
                                    :src="prevAndNext.nextImg"
                                    class="bg-img"
                                />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <!-- pc top banner end -->
        <bread-crumb
            v-if="!isMobileSize && !wordPressSSR"
            theme="standard"
            :detailInfo="info"
        />
        <Swiper
            v-if="!isMobileSize"
            class="swiper-pc detail-info-imgs"
            trackSource="detail-info-img"
            v-bind="options"
            ref="swiper"
            @init="onSwiperReady"
            @slideChange="handleSlideChange"
        >
            <Slide
                v-for="(items, index) in pictureTerms"
                :key="index"
                :class="`slide-pc slide-${items.length}`"
            >
                <div class="slide-left photo-item-pc">
                    <div
                        class="swiper-box"
                        @click="touched(index * 5, $event, items[0])"
                    >
                        <img-box
                            @load="onImgLoad(index * 5, $event)"
                            :lazy="lazyload"
                            :src="items[0]"
                            :persent="0.5"
                            :alt="imgAlt"
                            class="swiper-img"
                        >
                            <house-tag theme="v3" />
                        </img-box>
                    </div>
                    <span
                        class="house-count"
                        v-if="allImages.length > 1"
                        @click="touched()"
                        style="cursor: pointer"
                    >
                        <span class="iconfont icon-pic"></span>{{
                            $t('md-detail-info.seeAllPhotos', {
                                count: allImages.length
                            })
                        }}</span>
                </div>
                <div class="slide-right clearfix">
                    <div
                        :key="item_index"
                        v-for="(item, item_index) in items.slice(1)"
                        class="img-item photo-item-pc"
                    >
                        <div
                            class="swiper-box"
                            @click="
                                touched(
                                    index * 5 + item_index + 1,
                                    $event,
                                    item
                                )
                            "
                        >
                            <div class="swiper-video" v-if="item.type == '3d'">
                                <img-box
                                    :src="item.preview"
                                    :alt="videoImgAlt"
                                />
                            </div>
                            <img-box
                                v-else
                                @load="
                                    onImgLoad(
                                        index * 5 + item_index + 1,
                                        $event
                                    )
                                "
                                :lazy="lazyload"
                                :src="item"
                                :alt="imgAlt"
                                class="swiper-img"
                            />
                        </div>
                    </div>
                </div>
            </Slide>
            <div class="swiper-button-prev iconfont icon-prev disabled"></div>
            <div class="swiper-button-next iconfont icon-next"></div>
        </Swiper>
        <Swiper
            ref="swiper"
            v-else
            class="swiper-mobile detail-info-imgs"
            trackSource="detail-info-img"
            v-bind="options"
            @init="onSwiperReady"
            @slideChange="handleSlideChange"
        >
            <Slide v-for="(item, index) in allImages" :key="index">
                <div
                    class="swiper-box"
                    @click="touched(index, $event, item)"
                    :title="$t('md-detail-info.clickToZoomin')"
                >
                    <div class="swiper-video" v-if="item.type == 'video'">
                        <house-tag
                            v-if="infoFlag.exclusiveTag"
                            v-bind="infoFlag.exclusiveTag"
                            theme="v3"
                        />
                        <img-box
                            v-if="item.video.videoPreview"
                            :src="item.video.videoPreview"
                            :alt="videoImgAlt"
                        />
                        <div class="play"></div>
                    </div>
                    <div class="swiper-video" v-else-if="item.type == '3d'">
                        <house-tag
                            v-if="infoFlag.exclusiveTag"
                            v-bind="infoFlag.exclusiveTag"
                            theme="v3"
                        />
                        <img-box
                            :src="item.preview"
                            :alt="videoImgAlt"
                        />
                    </div>
                    <img-box
                        v-else
                        @load="onImgLoad(index, $event)"
                        :lazy="lazyload"
                        :src="item"
                        :alt="imgAlt"
                        class="swiper-img"
                    >
                        <house-tag
                            v-if="infoFlag.exclusiveTag"
                            v-bind="infoFlag.exclusiveTag"
                            theme="v3"
                        />
                    </img-box>
                </div>
            </Slide>

            <span
                v-if="allImages.length > 1"
                @click="touched(0)"
                class="house-count"
            >
                <span class="swiper-num-pagination">
                    {{
                        curPage == 0
                            ? allImages.length
                            : curPage + '/' + allImages.length
                    }}
                </span>
            </span>
        </Swiper>
        <PSwp
            :options="photoswipeOption"
            ref="pswp"
            defaultSize="1200x750"
            trackSource="detail-info-img"
        />
        <!--<VideoPlayer
            v-if="video && video.videoLink"
            theme="standard"
            ref="videoPlayer"
            :url="video && video.videoLink"
        ></VideoPlayer>-->
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import common from '../banner.js';
import price from './detail-info-header/price.vue';
import addr from '../_components/address.vue';
import shakeAnimate from '../shake-animate.vue';
import houseTag from '@/modules/md-house/_component/house-tag';
export default {
    emits: ['showFixedBannerChange'],
    mixins: [common],
    components: { price, addr, shakeAnimate, houseTag },
    data: function() {
        return {
            mobileStep: 1,
            pcStep: 5,
            pictureTerms: [],
            theme: 'standard',
            showFixedBanner: false
        };
    },
    computed: {
        ...mapState({
            prevAndNext: 'prevAndNext',
            infoFlag: 'infoFlag'
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        rootStyle() {
            return this.isMobileSize
                ? {
                    'max-width': '100vw'
                }
                : // fix AM-298689
                { 'min-height': '400px' };
        }
    },
    created() {
        let i = 0;
        while (i < this.allImages.length) {
            let items = [];
            for (let j = 0; j < 5; j++) {
                if (i + j < this.allImages.length) {
                    items.push(this.allImages[i + j]);
                }
            }
            this.pictureTerms.push(items);
            i = i + 5;
        }
    },
    methods: {
        onScroll() {
            if (!this.$refs.swiper) {
                return; 
            }
            let rect = this.$refs.swiper.$el.getBoundingClientRect();
            if (rect.top < 0) {
                this.showFixedBanner = true;
                this.$emit('showFixedBannerChange', true);
            } else {
                this.showFixedBanner = false;
                this.$emit('showFixedBannerChange', false);
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '@/theme/mixin.scss';

@mixin house-count() {
    position: absolute;
    top: 0;
    right: 0;
    color: white;
    padding: 5px 8px;
    background-color: rgba(0, 0, 0, 0.4);
    border-bottom-left-radius: 6px;
    .icon-pic {
        margin-right: 6px;
        &::before {
            vertical-align: -1px;
        }
    }
}
$right-width: 340px;
.listing-detail-banner.standard {
    position: relative;
    // height: 400px;
    // overflow: hidden;
    margin-bottom: 40px;

    .detail-info-imgs {
        // height: 100%;
        overflow: hidden;
        .swiper-button-prev,
        .swiper-button-next {
            position: absolute;
            width: 40px;
            height: 100px;
            border-radius: 0 10px 10px 0;
            background-color: rgba(0, 0, 0, 0.5);
            background-image: none;
            background-size: 100%;
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
            font-size: 20px;
            color: #fff;
            text-align: center;
            line-height: 100px;
            cursor: pointer;
            &::before {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            &::after {
                display: none;
            }
            &.swiper-button-disabled {
                opacity: 0.5;
            }
            &:hover {
                opacity: 0.7;
            }
        }
        .swiper-button-prev {
            left: 0;
        }
        .swiper-button-next {
            right: 0;
            border-radius: 10px 0 0 10px;
        }
        > .house-count {
            @include house-count;
            z-index: 2;
            font-size: 14px;
            padding: 10px 10px 7px 9px;
        }
    }

    .swiper-pc {
        display: block;
    }
    .swiper-box {
        height: 100%;
        width: 100%;
        cursor: pointer;
        .swiper-img {
            width: 100%;
            height: 100%;
            .house-status {
                position: absolute;
                left: 15px;
                top: 14px;
            }
            img {
                width: 100%;
                height: 100%;
            }
        }
        .swiper-video {
            height: 100%;
            position: relative;
            background: black;
            .house-status {
                position: absolute;
                left: 15px;
                top: 15px;
            }
            .play {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: url('//static.chimeroi.com/site3/images/play.png');
                background-size: cover;
                height: 60px;
                width: 60px;
            }
            .img-box {
                height: 100%;
            }
        }
    }

    .detail-info-imgs {
        height: 400px;
        .swiper-slide {
            height: 100%;
            width: 100%;
            display: flex;
        }
    }
    .slide-left,
    .slide-right {
        width: 50%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        position: relative;
    }
    .slide-left {
        margin-right: 2px;
        .house-count {
            @include house-count;
        }
    }
    .slide-1 {
        .slide-left {
            margin-right: 0px;
            width: 100%;
        }
        .slide-right {
            width: 0;
        }
    }
    .slide-2 {
        .slide-right {
            .img-item {
                width: 100%;
                height: 100%;
                padding-left: 2px;
            }
        }
    }
    .slide-3 {
        .slide-right {
            .img-item {
                width: 50%;
                height: 100%;
                padding-left: 2px;
                padding-right: 2px;
                &:last-of-type {
                    padding-right: 0px;
                }
            }
        }
    }
    .slide-4 {
        .slide-right {
            .img-item {
                width: 50%;
                height: 50%;
                padding: 0px 2px 2px;
                &:nth-child(2) {
                    padding-right: 0px;
                }
                &:last-of-type {
                    padding-bottom: 0px;
                    padding-top: 2px;
                }
            }
        }
    }
    .slide-5 {
        .slide-right {
            .img-item {
                width: 50%;
                height: 50%;
                padding: 0px 2px 2px;
                &:nth-child(2) {
                    padding-right: 0px;
                }
                &:nth-child(3) {
                    padding-bottom: 0px;
                    padding-top: 2px;
                }
                &:nth-child(4) {
                    padding-bottom: 0px;
                    padding-top: 2px;
                    padding-right: 0px;
                }
            }
        }
    }
    .fixed-banner {
        .banner-box .center .price-address {
            .origin-price {
                font-size: 28px;
                color: #000000;
            }
            .price_all {
                display: inline-block;
                .sold-price {
                    font-size: 28px;
                }
            }
            .trend-price {
                display: inline-block;
                margin-left: 10px;
            }
            .address {
                margin-top: 8px;
                .street {
                    font-family: var(--font-bold);
                }
                .city {
                    color: #595e6d;
                }
            }
        }
    }
    .save-share-container {
        padding: 0 15px;
        height: 45px;
        background-color: #2d3246;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        &.fixed {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 100;
        }
        .left-btn {
            color: #ffffff;
            .btn-putAway {
                transform: rotate(180deg);
                display: inline-block;
            }
            .iconfont {
                font-size: 18px;
            }
            .btn-text {
                margin-left: 3px;
                font-size: 18px;
            }
        }
        .right-btn {
            .item {
                margin-right: 20px;
                display: inline-block;
                &:last-of-type {
                    margin-right: 0;
                }
                &.save {
                    color: #f0454c;
                    .iconfont {
                        font-size: 20px;
                    }
                }
                &.share {
                    color: #a0a3af;
                    .iconfont {
                        font-size: 22px;
                    }
                }
            }
        }
    }
    // pc top banner
    .fixed-banner {
        width: 100%;
        min-height: 80px;
        padding: 10px 0;
        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
        background-color: #ffffff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: var(--level-medium);
        opacity: 0;
        visibility: hidden;
        -webkit-transition: all 0.3s ease;
        -moz-transition: all 0.3s ease;
        -ms-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        transition: all 0.3s ease;
        &.fixed {
            visibility: visible;
            opacity: 1;
        }
        .banner-box {
            margin: 0 auto;
            display: flex;
            justify-content: center;
            @media (min-width: 1210px) {
                .center {
                    margin: 0;
                }
            }
            .banner-left,
            .banner-right {
                width: 80px;
                padding: 0;
                position: relative;
                .bg-img-box {
                    opacity: 0;
                    &:after {
                        content: '';
                        position: absolute;
                        width: 100%;
                        height: 60px;
                        top: 0;
                        left: 0;
                        background-color: rgba(0, 0, 0, 0.1);
                    }
                    .bg-img {
                        width: 80px;
                        height: 60px;
                        display: inline-block;
                    }
                }
                .btn {
                    color: #515666;
                    position: absolute;
                    height: 25px;
                    width: 100%;
                    border-radius: 2px;
                    border: solid 1px #515666;
                    text-align: center;
                    font-size: 14px;
                    font-family: var(--font-bold);
                    line-height: 23px;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 10;
                    display: block;
                    &:hover {
                        cursor: pointer;
                        border: none;
                        color: #ffffff;
                        line-height: 25px;
                        + .bg-img-box {
                            opacity: 1;
                        }
                    }
                    .iconfont {
                        font-size: 12px;
                        &.prev {
                            transform: rotate(180deg);
                            display: inline-block;
                        }
                    }
                }
            }
            .center {
                display: flex;
                justify-content: space-between;
                align-items: center;
                &.mg-container {
                    &:after {
                        content: none;
                    }
                    @media (max-width: 1209px) {
                        width: auto;
                        flex: 1;
                        margin: 0;
                    }
                }
                .address {
                    max-width: 600px;
                    @media (max-width: 1209px) {
                        max-width: 400px;
                    }
                }
                .save-share-tour {
                    .item {
                        cursor: pointer;
                        text-align: center;
                        display: inline-block;
                        height: 40px;
                        margin-right: 20px;
                        &:last-child {
                            margin-right: 0;
                        }
                        > .iconfont {
                            font-size: 18px;
                            display: block;
                        }
                        &.save,
                        &.share {
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            border: solid 1px #e5e8f1;
                            line-height: 38px;
                            &:hover {
                                background-color: #f8f8f8;
                            }
                        }
                        &.save {
                            color: #f0454c;
                            .hover {
                                display: none;
                            }
                            &.active,
                            &:hover {
                                .default {
                                    display: none;
                                }
                                .hover {
                                    display: block;
                                }
                            }
                        }
                        &.share {
                            position: relative;
                            line-height: 36px;
                            .default {
                                color: #515666;
                                display: block;
                            }
                            .hover {
                                color: #03c9ff;
                                display: none;
                            }
                            &:hover {
                                .default {
                                    display: none;
                                }
                                .hover {
                                    display: block;
                                }
                                .popper {
                                    visibility: visible;
                                }
                            }
                            .popper {
                                position: absolute;
                                top: 100%;
                                left: 50%;
                                padding-top: 15px;
                                z-index: var(--level-medium);
                                transform: translateX(-50%);
                                visibility: hidden;
                            }
                        }
                        &.tour {
                            @include color-button-hover();
                            position: relative;
                            vertical-align: top;
                            padding: 10px 18px;
                            border-radius: 2px;
                            font-size: 16px;
                            font-family: var(--font-bold);
                            @include color-button();

                            .text {
                                display: inline-block;
                                max-width: 250px;
                                @include ellipsis();
                            }
                        }
                    }
                }
            }
            .banner-left {
                margin-right: 20px;
            }
            .banner-right {
                margin-left: 20px;
            }
        }
    }
}
@include media-1280 {
    .listing-detail-banner.standard {
        margin-bottom: 30px;
    }
}
@include media-600 {
    .listing-detail-banner.standard {
        margin-top: 0;
        margin-bottom: 0;
        // height: 200px;
        .detail-info-imgs {
            height: 250px;
        }
        .swiper-pc {
            display: none;
        }
    }
}

@mixin slideLeft() {
    width: 50%;
    flex: 1;
    height: 100%;
    margin-right: 2px;
}
</style>
